import React, { useState } from 'react';

interface FinalCTASectionProps {
  onEmailSubmit: (email: string) => void;
}

const FinalCTASection: React.FC<FinalCTASectionProps> = ({ onEmailSubmit }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      onEmailSubmit(email);
    }
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-red-600 to-orange-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-8">
          지금이 <span className="text-yellow-300">마지막 기회</span>
        </h2>
        
        <p className="text-2xl mb-12 text-red-100">
          매주 진짜 AI 트렌드를 받아보세요
        </p>
        
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 mb-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl mb-3">🆓</div>
              <h3 className="font-bold text-lg mb-2">무료 구독</h3>
              <p className="text-red-100">평생 무료로 제공</p>
            </div>
            <div>
              <div className="text-3xl mb-3">🚪</div>
              <h3 className="font-bold text-lg mb-2">즉시 취소 가능</h3>
              <p className="text-red-100">원클릭으로 구독 해지</p>
            </div>
            <div>
              <div className="text-3xl mb-3">⚡</div>
              <h3 className="font-bold text-lg mb-2">30분 → 3분 요약</h3>
              <p className="text-red-100">핵심만 빠르게</p>
            </div>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
          <div className="flex flex-col sm:flex-row gap-4 mb-6">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="이메일 주소를 입력하세요"
              className="flex-1 px-6 py-4 text-lg rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-yellow-300"
              required
            />
            <button
              type="submit"
              className="bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold px-8 py-4 text-lg rounded-lg transition-colors duration-200 whitespace-nowrap"
            >
              무료 구독하기
            </button>
          </div>
        </form>
        
        <p className="text-red-200 text-sm">
          ⚠️ 이 기회를 놓치면 다시 찾기 어려울 수 있습니다
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;
